// 基础设置 form
export const formSchemas = [
  {
    field: 'username',
    defaultValue: '',
    component: 'Input',
    label: '账号',
    placeholder: '请输入账号',
    rules: [
      {
        required: true,
        message: '账号不能为空'
      }
    ]
  },
  {
    field: 'password',
    defaultValue: '',
    component: 'Input',
    label: '密码',
    placeholder: '请输入密码',
    rules: []
  },
  {
    field: 'tenantId',
    defaultValue: '',
    component: 'Input',
    label: '租户id',
    disabled: true,
    placeholder: '',
    rules: [
      {
        required: true,
        message: '租户不能为空'
      }
    ]
  },
  {
    field: 'lastLoginClinic',
    defaultValue: '',
    component: 'Input',
    label: '诊所id',
    disabled: true,
    placeholder: '',
    rules: [
      {
        required: true,
        message: '租户不能为空'
      }
    ]
  }
  // {
  //   field: 'userRoleList',
  //   defaultValue: [],
  //   component: 'Checkbox',
  //   label: '用户角色',
  //   placeholder: '请选择用户角色',
  //   checkboxArr: [],
  //   rules: [
  //     {
  //       required: true,
  //       message: '用户角色不能为空'
  //     },
  //     {
  //       validator: (rule, value, callback) => {
  //         if (!value.length) {
  //           callback(new Error('用户角色不能为空'))
  //         } else {
  //           callback()
  //         }
  //       }
  //     }
  //   ]
  // }
]
